import "./NewsArchive.module.css";
import Header from "@/reusable_sections/Header";
import RelatedArticlesGrid from "./sections/RelatedArticlesGrid";
import Pagination from "./sections/Pagination";
import Footer from "@/reusable_sections/Footer";
export default function NewsArchivePage() {
  return <div>
      <Header />
      <RelatedArticlesGrid />
      <Pagination />
      <Footer />
    </div>;
}